import React, {Component} from "react";
import Header from "../../../Containers/Header/Header";
import Footer from "../../../Containers/Footer";
import PageTopMenu from "../../../Containers/PageTopMenu";
import ReadingHomeworkPage from "../Reading/Homework";
import Loading from "../../../Containers/Loading";

class ReadingHomework extends Component {

    state = {
        // loading
        isLoadingHide: false
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return (
            <div className="beaconWrapper">
                <Header />
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <h2 className="screenOut">오늘의 ReadingHomework 숙제</h2>
                        <PageTopMenu onClick={() => {
                            this.props.history.goBack()
                        }}/>
                        <div className="pageContents">
                            <ReadingHomeworkPage categoryName="reading"/>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default ReadingHomework;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Homework/ReadingHomework.js